// myapp/src/components/common/PortalGuard.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { useAppAuth } from '../../context/AppAuthContext';
import { ROLES } from '../../constants/roles';

export const AdminPortalGuard: React.FC = () => {
  const { role, isAuthenticated } = useAdminAuth();

  if (!isAuthenticated) {
    return <Outlet />;
  }

  // Cross-portal validation for authenticated users
  if (role !== ROLES.SUPER_ADMIN) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Enforce subdomain check as defense in depth
  if (!window.location.hostname.startsWith('admin.')) {
    return <Navigate to="/portal-mismatch" replace />;
  }

  return <Outlet />;
};

export const AppPortalGuard: React.FC = () => {
  const { role, isAuthenticated, loading } = useAppAuth();

  // Don't make any decisions until auth state is resolved
  if (loading) {
    return <Outlet />;
  }

  if (!isAuthenticated) {
    return <Outlet />;
  }

  // Cross-portal validation for authenticated users
  if (role === ROLES.SUPER_ADMIN) {
    return <Navigate to="/portal-mismatch" replace />;
  }

  // Enforce subdomain check as defense in depth
  if (!window.location.hostname.startsWith('app.')) {
    return <Navigate to="/portal-mismatch" replace />;
  }

  return <Outlet />;
};
